import { gql, graphql } from "react-apollo"
import { GetSlidesQuery } from "./withSlides"

const MUTATE_DELETE_SLIDE = gql`
  mutation DeleteSlide($attractLoopId: ID!, $id: ID!) {
    deleteSlide(attractLoopId: $attractLoopId, id: $id) {
      id
      title
    }
  }
`

const mutateDeleteSlide = graphql(MUTATE_DELETE_SLIDE, {
  name: "mutateDeleteSlide",
  options: ({ match }) => {
    if (!match) return {}
    return {
      refetchQueries: [
        {
          query: GetSlidesQuery,
          variables: { attractLoopId: match.params.parentId }
        }
      ]
    }
  },
  props: ({ mutateDeleteSlide }) => ({
    deleteSlide: (attractLoopId: string, id: string) =>
      mutateDeleteSlide({
        variables: { id, attractLoopId }
      })
  })
})

export default mutateDeleteSlide



// WEBPACK FOOTER //
// ./src/Slides/queries/mutateDeleteSlide.js